import en from "commonAssets/i18n/en";
import merge from "lodash.merge";

const overrides = {
    otp_instructions_1:
        "A one-time verification code has just been sent via text message to your phone number on file.",
    otp_instructions_2: "Please enter the 6 digit code below.",
    privacy_policy_url:
        "https://angeion-public.s3.us-east-1.amazonaws.com/docs/2026/02/25-12-23_Angeion_Online_Privacy_+Policy-RM.pdf",
};

export default {
    en: merge({}, en, overrides),
};
